import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/`;

const getCustomersByShipDateId = async (shipDateId) => {
    return await axios.post(API_URL + 'order/customerbyshipdate', shipDateId);
};

const getPersonNotPaidData = async (formData) => {
    return await axios.post(API_URL + 'order/nopaidperson', formData);
};

const getOldPersonNotPaidData = async (customerId) => {
    return await axios.post(API_URL + 'order/oldnotpaiddata', {customerId});
};

const getOldPersonNotPaid = async (formData) => {
    return await axios.post(API_URL + 'order/oldnotpaid', formData);
};

const getPersonOldNotPaidDataById = async (formData) => {
    return await axios.post(API_URL + 'order/nopaidpersonbyid', formData);
};

export default {
    getCustomersByShipDateId,
    getPersonNotPaidData,
    getOldPersonNotPaid,
    getPersonOldNotPaidDataById,
    getOldPersonNotPaidData
};
